import responsiveHelper from "@core/helpers/responsiveHelper";
import { CardCarousel, DisplayTable, FormInput } from "@policoders/ds";

import { ITechnicalSheetFormProps, useTechnicalSheetForm } from "./technical-sheet.form.hook";

const TechnicalSheetForm = ({ data, onChange }: ITechnicalSheetFormProps) => {
  const {
    lines,
    tActions,
    tColumns,
    tHeaderButtons,
    state,
    estimativas,
    margemLucro,
    handleChange,
    handleEdit,
  } = useTechnicalSheetForm({
    data,
    onChange,
  });

  return (
    <div>
      <div className="row">
        <div className="d-none d-sm-block col-sm-3 col-lg-3 col-xl-2">
          <FormInput
            type="text"
            label="Código"
            field="recipeCode"
            value={state.recipeCode}
            disabled={state.recipeCode === "0"}
            onChange={handleChange}
          />
        </div>
        <div className="col-12 col-sm-9 col-lg-9 col-xl-5">
          <FormInput
            type="text"
            label="Descrição"
            field="recipeName"
            value={state.recipeName}
            onChange={handleChange}
          />
        </div>
        <div className="col-6 col-sm-4 col-lg-4 col-xl-1">
          <FormInput
            type="number"
            label="Porções"
            field="portions"
            value={state.portions}
            onChange={handleChange}
          />
        </div>
        <div className="col-6 col-sm-4 col-lg-4 col-xl-2">
          <FormInput
            type="number"
            label="Custo por porção"
            field="portionCost"
            value={state.portionCost}
            onChange={handleChange}
          />
        </div>
        <div className="col-12 col-sm-4 col-lg-4 col-xl-2">
          <FormInput
            type="number"
            label={`Preço venda (${estimativas.percentualReal}%)`}
            field="salePrice"
            value={state.salePrice}
            onChange={handleChange}
          />
        </div>
      </div>
      <div>
        <div className="mb-2">Itens</div>

        {/* <CardCarousel
          headerButton={tHeaderButtons.buttonNew}
          hidden={!responsiveHelper.isSmallScreen()}
          items={lines}
          labels={tColumns}
          onItemClick={handleEdit}
        /> */}

        {/* {!responsiveHelper.isSmallScreen() && ( */}
        <DisplayTable
          actions={tActions}
          columns={tColumns}
          headerButtons={tHeaderButtons}
          lines={lines}
          groupLinesBy={"groupItem"}
          onLineClick={handleEdit}
        />
        {/* )} */}

        <div className="mt-3 mb-2">Estimativas</div>

        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-12 col-lg-6 estimativas">
                <div>
                  Custo total{" "}
                  <span className="small text-muted">(*soma do custo bruto de cada item)</span>
                  <span> {estimativas.custoTotal}</span>
                </div>
                <div>
                  Peso total <span className="small text-muted">(*soma do peso de cada item)</span>
                  <span> {estimativas.pesoTotal}</span>
                </div>
                <div>
                  Custo porção <span className="small text-muted">(*custo total / porções)</span>
                  <span> {estimativas.custoPorcao}</span>
                </div>
                <div>
                  Peso porção <span className="small text-muted">(*peso total / porções)</span>
                  <span> {estimativas.pesoPorcao}</span>
                </div>
              </div>
              <div className="col-12 col-lg-6 margem-lucro">
                <div>
                  <b>Margem 15%</b>
                  <span> Porção: {margemLucro?.p15?.unit}</span>
                  <span> Receita: {margemLucro?.p15?.total}</span>
                </div>
                <div>
                  <b>Margem 30%</b>
                  <span> Porção: {margemLucro?.p30?.unit}</span>
                  <span> Receita: {margemLucro?.p30?.total}</span>
                </div>
                <div>
                  <b>Margem 40%</b>
                  <span> Porção: {margemLucro?.p40?.unit}</span>
                  <span> Receita: {margemLucro?.p40?.total}</span>
                </div>
                <div>
                  <b>Margem 50%</b>
                  <span> Porção: {margemLucro?.p50?.unit}</span>
                  <span> Receita: {margemLucro?.p50?.total}</span>
                </div>
                <div>
                  <b>Margem 100%</b>
                  <span> Porção: {margemLucro?.p100?.unit}</span>
                  <span> Receita: {margemLucro?.p100?.total}</span>
                </div>
                <div>
                  <b>Margem 150%</b>
                  <span> Porção: {margemLucro?.p150?.unit}</span>
                  <span> Receita: {margemLucro?.p150?.total}</span>
                </div>
                <div>
                  <b>Margem 200%</b>
                  <span> Porção: {margemLucro?.p200?.unit}</span>
                  <span> Receita: {margemLucro?.p200?.total}</span>
                </div>
                <div>
                  <b>Margem 300%</b>
                  <span> Porção: {margemLucro?.p300?.unit}</span>
                  <span> Receita: {margemLucro?.p300?.total}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TechnicalSheetForm;
